import React from "react";
import "../store.css"
import { CartContext } from "../../context/CartContext";
import { useContext } from "react";

const ProductCard = (props) => {



  const { cartItems,addToCart,  emptyCart ,calculateTotalAmount} = useContext(CartContext)

  return (
    <div className="product-card">
        <img
        src={props.product.url}
        alt={props.product.category}
        className="category-image"
      />
      <h3 className="product-name">{props.product.name}</h3>
      <p className="product-price">${props.product.price}</p>
      <div className="color-options">
  <select className="color-select">
    {props.product.color.map((c, index) => (
      <option
        key={index}
        value={c}
        style={{ backgroundColor: c, color: '#fff' }}
      >
        {c}
      </option>
    ))}
  </select>
</div>
      <p className="product-details">
        Size: {props.product.size} | Only {props.product.stock} remaining
      </p>
      <button className="add-to-cart" onClick={()=>addToCart(props.product._id)}>Add to Cart</button>
    </div>
  );
};

export default ProductCard;